"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.floatingNotification = void 0;

var _emotion = require("emotion");

var animation =
/*#__PURE__*/
(0, _emotion.keyframes)("from{bottom:-100px;opacity:1;}to{bottom:calc(100vh + 100px);opacity:0;}");

var floatingNotification = function floatingNotification(left) {
  return (
    /*#__PURE__*/
    (0, _emotion.css)("position:fixed;animation:", animation, " 9s cubic-bezier(0.01,0.39,0.99,0.58);left:", left, "%;bottom:-100px;@media (max-width:767px){left:", left - 35, "%;}")
  );
};

exports.floatingNotification = floatingNotification;